import { Component, Input } from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'

@Component({
  selector: 'mb-checkout-customer-no-form-partial',
  templateUrl: './mb-checkout-customer-no-form-partial.component.html',
})
export class MbCheckoutCustomerNoFormPartialComponent {

  @Input() formGroup: UntypedFormGroup | undefined
  @Input() customerNoLabelKey: string = 'contact.customerNumber'
  @Input() isFormDisabled: boolean | undefined

}
